import React from 'react';
import { TabTableContainer, Title } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { GridColumns } from '@material-ui/data-grid';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { formatColWithDate, valueGridMoneyFormatter } from '@components/datagrid/custom.datagrid.props';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import CustomGridCellVipIcon from '@components/datagrid/custom.grid.cell.vip.icon';
import { useGame } from '@domain/game.selection/game.selection.hook';
import { GameType } from '@domain/game.selection/types/game.type';

const commonsColumns: GridColumns = [
  { field: 'taskCount', headerName: 'Count', width: 115 },
  { field: 'taskParam', headerName: 'Param', width: 120 },
  { field: 'collectedDate', headerName: 'Collected Date', ...formatColWithDate, width: 170 },
];

const praiaColumns: GridColumns = [
  ...commonsColumns,
  { field: 'daily', headerName: 'Daily', width: 108 },
  { field: 'task', headerName: 'Task', width: 190 },
  { field: 'taskRequired', headerName: 'Required', width: 133 },
  { field: 'coins', headerName: 'Coins', width: 120, type: 'number', valueFormatter: valueGridMoneyFormatter },
  { field: 'cash', headerName: 'Cash', width: 120, type: 'number', valueFormatter: valueGridMoneyFormatter },
  { field: 'vip', headerName: 'Vip', width: 97, renderCell: CustomGridCellVipIcon },
  { field: 'timestamp', headerName: 'Timestamp', ...formatColWithDate, width: 149 },
  { field: 'startDate', headerName: 'Start Date', ...formatColWithDate, width: 149 },
  { field: 'closureDate', headerName: 'Closure Date', ...formatColWithDate, width: 159 },
];

const rexColumns: GridColumns = [
  ...commonsColumns,
  { field: 'taskOrder', headerName: 'Task Order', width: 148 },
  { field: 'missionId', headerName: 'Mission Id', width: 143 },
  { field: 'difficulty', headerName: 'Difficulty', width: 134 },
  { field: 'taskId', headerName: 'Task Id', width: 125 },
  { field: 'gameId', headerName: 'Game Id', width: 200 },
];

interface MissionsData {
  daily: number;
  task: string;
  taskParam: string;
  taskCount: number;
  taskRequired: number;
  coins: string;
  cash: string;
  vip: string;
  timestamp: string;
  collectedDate: string;
  startDate: string;
  closureDate: string;
}

const Missions = ({ player }: PlayerDataProps) => {
  const game = useGame();
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<MissionsData[]>(`/admin/daily-missions/player/${requestPid}`, { params: { page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });

  // const rows = responseData?.map(createData) || [];
  const rows = responseData || [];

  const total = rows.length;

  return (
    <>
      <TabTableContainer>
        <Title>Daily Missions ({total})</Title>
        <MainDataGrid
          columns={game.type === GameType.Praia ? praiaColumns : rexColumns}
          rows={rows}
          loading={loading}
          error={error}
          pageCount={pageCount}
        />
      </TabTableContainer>
    </>
  );
};

export default Missions;
